<template>
  <svg
    width="165"
    height="160"
    viewBox="0 0 165 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M84.8586 140.201C117.84 140.201 144.577 113.445 144.577 80.4399C144.577 47.4348 117.84 20.679 84.8586 20.679C51.8773 20.679 25.1406 47.4348 25.1406 80.4399C25.1406 113.445 51.8773 140.201 84.8586 140.201Z"
      fill="url(#paint0_linear_10083_74572)"
    />
    <mask
      id="mask0_10083_74572"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="-2"
      y="20"
      width="148"
      height="124"
    >
      <path
        d="M145.022 79.9619C145.022 112.967 118.266 139.723 85.2608 139.723C65.8141 139.723 -1.02148 154.716 -1.02148 127.192C-1.02148 99.6682 -1.02148 32.7315 -1.02148 32.7315C30.2906 32.7315 56.1285 20.2009 85.2608 20.2009C118.266 20.2009 145.022 46.9568 145.022 79.9619Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_10083_74572)">
      <rect
        opacity="0.6"
        x="20.1875"
        y="44.137"
        width="77.6033"
        height="17.2452"
        rx="8.62259"
        fill="url(#paint1_linear_10083_74572)"
      />
      <path
        d="M32.0435 52.7595H47.133"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M53.6001 52.7595H85.9348"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
      />
      <g filter="url(#filter0_d_10083_74572)">
        <rect
          x="105.443"
          y="44.137"
          width="58.5568"
          height="17.2452"
          rx="8.62259"
          fill="url(#paint2_linear_10083_74572)"
        />
      </g>
      <path
        d="M118.902 52.7595H151.237"
        stroke="#C1D4F5"
        stroke-width="3"
        stroke-linecap="round"
      />
      <g filter="url(#filter1_d_10083_74572)">
        <rect
          x="22.4551"
          y="71.3589"
          width="58.5568"
          height="17.2452"
          rx="8.62259"
          fill="url(#paint3_linear_10083_74572)"
        />
      </g>
      <path
        d="M35.9146 79.9814H68.2492"
        stroke="#C1D4F5"
        stroke-width="3"
        stroke-linecap="round"
      />
      <rect
        opacity="0.6"
        x="88.6641"
        y="71.3589"
        width="73.0684"
        height="17.2452"
        rx="8.62259"
        fill="url(#paint4_linear_10083_74572)"
      />
      <path
        d="M148.97 79.9814H138.402"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M131.737 79.9814H102.124"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
      />
      <g filter="url(#filter2_d_10083_74572)">
        <rect
          x="85.9429"
          y="98.5806"
          width="58.5568"
          height="17.2452"
          rx="8.62259"
          fill="url(#paint5_linear_10083_74572)"
        />
      </g>
      <path
        d="M99.4023 107.203H131.737"
        stroke="#C1D4F5"
        stroke-width="3"
        stroke-linecap="round"
      />
      <g filter="url(#filter3_d_10083_74572)">
        <rect
          x="41.6875"
          y="98.5806"
          width="38.6035"
          height="17.2452"
          rx="8.62259"
          fill="url(#paint6_linear_10083_74572)"
        />
      </g>
      <path
        d="M55.147 107.203H67.5283"
        stroke="#C1D4F5"
        stroke-width="3"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10083_74572"
        x="83.4429"
        y="33.137"
        width="102.557"
        height="61.2451"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74572"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74572"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_74572"
        x="0.455078"
        y="60.3589"
        width="102.557"
        height="61.2451"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74572"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74572"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_10083_74572"
        x="63.9429"
        y="87.5806"
        width="102.557"
        height="61.2451"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74572"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74572"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_10083_74572"
        x="19.6875"
        y="87.5806"
        width="82.6035"
        height="61.2451"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74572"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74572"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_74572"
        x1="25.1388"
        y1="140.2"
        x2="144.661"
        y2="20.7635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_74572"
        x1="20.1863"
        y1="61.382"
        x2="27.4901"
        y2="28.5146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_74572"
        x1="134.702"
        y1="43.7381"
        x2="134.702"
        y2="61.568"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_74572"
        x1="51.7144"
        y1="70.96"
        x2="51.7144"
        y2="88.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_74572"
        x1="88.6629"
        y1="88.604"
        x2="96.3736"
        y2="55.9333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_74572"
        x1="115.202"
        y1="98.1817"
        x2="115.202"
        y2="116.012"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_74572"
        x1="60.9766"
        y1="98.1817"
        x2="60.9766"
        y2="116.012"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
